import type { VoidFunctionComponent } from 'react';

import { window } from '../../../../globals';
import { isOrgInFreeTier } from '../../../../helpers/subscriptions';
import Button, { NavigationButton } from '../../../generic/Button';
import PaidFeatureGate from '../../../generic/Gates/PaidFeatureGate';
import { icons, IconText } from '../../../generic/Icon';
import { DOCS_URL } from '../../../generic/Link';
import Header from '../../../shared/settings/SettingsPageHeader';
import Section from '../../../shared/settings/SettingsPageSection';
import useCocoapodsSettings from '../useCocoapodsSettings';

import Source from './Source';

const COCOAPODS_DOCS_LINK = `${DOCS_URL}/ios`;

const CocoaSettings: VoidFunctionComponent = () => {
  const {
    sources,
    isSaving,
    onRemoveSource,
    onAddSource,
    onUpdateSource,
    onSaveSettings,
    isSaveButtonDisabled,
    isLoading,
  } = useCocoapodsSettings(
    window.user?.organizationId as number,
  );

  const isFreeOrg = isOrgInFreeTier();

  return (
    <PaidFeatureGate isRestricted={isFreeOrg} hidePill>
      <Header heading="Cocoapods Settings">
        <Header.SaveButton
          onClick={onSaveSettings}
          isDisabled={isSaveButtonDisabled || isLoading}
          isLoading={isSaving}
        />
      </Header>
      <Section>
        <Section.Left heading="Source Repositories">
          <Section.Paragraph>
            Configure your Cocoapods podspec repo settings.
          </Section.Paragraph>
          <NavigationButton
            to={COCOAPODS_DOCS_LINK}
            size="medium"
            type="secondary"
            openInNewTab
          >
            View documentation
          </NavigationButton>
        </Section.Left>
        <Section.Right>
          {(sources || []).map((source, index) =>
            <Source
              id={source.id}
              url={source.url}
              onUpdateSource={(value: string) => {
                onUpdateSource(index, value);
              }}
              onRemoveSource={() => onRemoveSource(index)}
            />,
          )}
          <Button
            type="secondary"
            size="medium"
            onClick={onAddSource}
          >
            <IconText icon={icons.plus} text="Add repository" />
          </Button>
        </Section.Right>
      </Section>
    </PaidFeatureGate>
  );
};

export default CocoaSettings;
